// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"7d850ceb","237":"47a33e21","385":"73c64318","593":"f40d64d3","731":"90b5472c","864":"49cb6edd"}[chunkId] + ".css";
};